import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BodyColorService } from '../../../service/bodyColor/bodycolor.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';

interface options {
  value: boolean,
  name: string
}

@Component({
    selector: 'app-roleplay-step1',
    templateUrl: './roleplay-step1.component.html',
    styleUrls: ['../../../../assets/css/roleplay.scss', './roleplay-step1.component.scss'],
    standalone: false
})

export class RoleplayStep1Component implements OnInit {

  step1Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  currentProfileId: number;
  profileLength: number;
  color: string = '#e8e6e3';
  scenario_name: string ="";
  submittedValueCareer: any = [];
  submittedValueFamily: any = [];
  submittedValueProfession: any = [];
  subscriptionCareer: Subscription;
  subscriptionFamily: Subscription;
  subscriptionProfession: Subscription;
  profiles: any [];
  professionalGoals= [];
  careerHighlights= [];
  familyHighlights= [];
  metaData: any[] = [];
  isEditMode: boolean = false;
  test:any = [];
  toggleState: { [key: number]: boolean } = {};
  togglevalue: boolean = false;
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');

  constructor(public Router: Router, private fb: FormBuilder, private dialog: MatDialog,
    private sharedService: RoleplayService, private bodyColorService: BodyColorService) {
  }

  ngOnInit(): void {


    this.sharedService.getMetaDataData().subscribe();
    this.sharedService.editMode$.subscribe(mode => {
      this.isEditMode = mode;
    });

    this.subscription = this.sharedService.getDoctorListData(this.business_unit_code).subscribe({
      next: (response) => {
        response.forEach(profile => {
          profile.avatar_url = this.sharedService.getDoctorProfileImageUrl(profile.avatar_file_name)
        });
        this.profiles = response;
        if (this.sharedService.rolePlayScenarioData.dr_profile_id) {
      const index = this.profiles.findIndex(profile => profile.profile_id === this.sharedService.rolePlayScenarioData.dr_profile_id);
      this.setProfile(index);
      this.setupCheckbox(index);
      this.profileLength = this.profiles.length - 1;
      
      } else {
        this.profileLength = this.profiles.length - 1;
        if (this.isEditMode) {
          this.sharedService.data$.subscribe({
            next: data => { 
              this.metaData = data;
              const doctorId = this.metaData[0].dr_profile_id;
              this.scenario_name = this.metaData[0].scenario_name;
              const index = this.profiles.findIndex(profile => profile.profile_id === doctorId);
              this.togglevalue =this.metaData[0].avtar_enabled;
    // this.togglevalue = this.metaData[0].avatar_enabled;
              this.setProfile(index);
              this.setupCheckbox(index);
            },
            error: error => console.error('Error receiving data', error),
            complete: () => { 
              
             }
          });
        } else {
        this.setProfile(0);
        this.setupCheckbox(0);
      }
    }
        
      },
      error: (error) => {
        console.error('Error fetching doctor list data', error);
      }
    });

    this.step1Form = this.fb.group({
      customerName: ['', Validators.required],
      avatar: [false, Validators.required],
      age: ['', Validators.required],
      occupation: ['', Validators.required],
      careerHighlights: this.fb.array(this.careerHighlights.map(x => false)),
      familyHighlights: this.fb.array(this.familyHighlights.map(x => false)),
      professionalGoals: this.fb.array(this.professionalGoals.map(x => false))
    });
   

    // this.bodyColorService.setBodyColor(this.color);
    
  }
  setProfile(id: number) {
    const avatar_status = this.sharedService.rolePlayScenarioData.avtar_enabled;

    this.step1Form.patchValue({
      customerName: this.profiles[id].full_name,
      age: this.profiles[id].age,
      occupation: this.profiles[id].occupation,
      // avatar: this.profiles[id].avatar_enabled
      avatar: avatar_status || this.togglevalue

    });
    this.currentProfileId = id;
  }
  nextProfile() {
    if(this.profiles.length > (this.currentProfileId+1) ) {
      ++this.currentProfileId;
      this.setProfile(this.currentProfileId);
      this.setupCheckbox(this.currentProfileId);
    }
  }
  previousProfile() {
    if(this.profiles.length > this.currentProfileId && this.currentProfileId !== 0) {
      --this.currentProfileId;
        this.setProfile(this.currentProfileId);
        this.setupCheckbox(this.currentProfileId);
    }
  }

  toggleAvatar(isEnabled: boolean): void {
    this.togglevalue = !isEnabled;
  }

  splitStringByComma(str) {
    // Check if the string contains a comma
    if (str.includes(',')) {
      // Split the string by commas
      return str.split(',');
    } else {
      // Return the string as a single-element array
      return [str];
    }
  }
  setupCheckbox(id: number) {
    this.careerHighlights = this.splitStringByComma(this.profiles[id].career_high);
    this.careerHighlights = this.careerHighlights.reduce ((acc, data) => {
      const jsonObject = { label: data };  
      acc.push(jsonObject);  
      return acc;

    }, [])
    const careerHighlightsFormArray = this.fb.array(this.careerHighlights);
    this.step1Form.setControl('careerHighlights', careerHighlightsFormArray);


    this.professionalGoals = this.splitStringByComma(this.profiles[id].professional_goals);
    this.professionalGoals = this.professionalGoals.reduce ((acc, data) => {
      const jsonObject = { label: data };  
      acc.push(jsonObject);  
      return acc;

    }, [])
    const professionalGoalsFormArray = this.fb.array(this.professionalGoals);
    this.step1Form.setControl('professionalGoals', professionalGoalsFormArray);
  }
  updateSelected(optionIndex: number, optionId: string, event: Event, type: string) {
    switch (type) {
      case 'C':
        this.updateSelectedSection(optionIndex, optionId, event, this.careerHighlights, 'careerHighlights');
        break;
      case 'F':
        this.updateSelectedSection(optionIndex, optionId, event, this.familyHighlights, 'familyHighlights');
        break;
      case 'P':
        this.updateSelectedSection(optionIndex, optionId, event, this.professionalGoals, 'professionalGoals');
        break;
    }
  }
  updateSelectedSection(optionIndex: number, optionId: string, event: Event, sectionArray: any, formControlName: string) {
    const isChecked = (event.target as HTMLInputElement).checked;
    sectionArray[optionIndex].checked = isChecked;
  }
  skipToChat() {
    this.Router.navigate(['/app-abiomed-chat', { mode: 'roleplay' }], { skipLocationChange: true });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
 goBack() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { showTitle: true,message: 'If you close this, all previous steps will need to be redone, Continue?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      this.Router.navigate(['/app-trainee-dasboard'], { skipLocationChange: true });
    });
  }


  retainSelectedMetaData(){
    const checkboxControl1 = (this.step1Form.controls['careerHighlights'] as FormArray);
    const checkboxControl2 = (this.step1Form.controls['familyHighlights'] as FormArray);
    const checkboxControl3 = (this.step1Form.controls['professionalGoals'] as FormArray);
    const formValue1 = {
      ...this.step1Form.value,
      careerHighlightsF: checkboxControl1.value.filter(value => !!value),
      familyHighlightsF: checkboxControl2.value.filter(value => !!value),
      professionalGoalsF: checkboxControl3.value.filter(value => !!value)
    }

    this.submittedValueCareer = formValue1.careerHighlightsF;
    this.submittedValueFamily = formValue1.familyHighlightsF;
    this.submittedValueProfession = formValue1.professionalGoalsF;
   
    this.sharedData.customer_name = this.step1Form.value.customerName;
    this.sharedData.age = this.step1Form.value.age;
    this.sharedData.avtar_enabled= this.step1Form.value.avatar;
    this.sharedData.occupation = this.step1Form.value.occupation;
    this.sharedData.career_high = this.submittedValueCareer.toString(); 
    this.sharedData.professional_goals = this.submittedValueProfession.toString();
    this.sharedService.changeData([this.sharedData]);
    this.sharedService.rolePlayScenarioData.dr_profile_id = this.profiles[this.currentProfileId].profile_id;
    this.sharedService.rolePlayScenarioData.avtar_enabled = this.step1Form.value.avatar;
  }

  goToStep(id: number) {
    const stepper_data: StepperContent = this.sharedService.stepperContent.find(stepper => stepper.stepId == id);
    this.changeStepper(stepper_data);
  }

  changeStepper(stepper_data:StepperContent){
    console.log('Step1 : changeStepper: ', stepper_data);
    this.retainSelectedMetaData();
    this.sharedService.changeStep(stepper_data);
  }
}
